import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {StoreState} from '@redux/reducers';
import {SchoolService} from '@services/school.service';
import {FirstAdminLoadedAction, SchoolsLoadedAction} from '@redux/actions/super-admin.action';
import {Observable} from 'rxjs';
import {School} from '@model/school';
import {StaffMember} from '@model/staffMember';
import {StaffMemberService} from '@services/staffMember.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable()
export class SuperAdminFacadeService {

  schools$: Observable<School[]>;

  firstAdmin$: Observable<StaffMember>;

  private readonly MAX_FILE_SIZE = 250 * 1024;

  private readonly SNACKBAR_DURATION =  2000;

  constructor(private _store: Store<StoreState>,
              private _schoolService: SchoolService,
              private _staffMemberService: StaffMemberService,
              private _snackBar: MatSnackBar) {
    this.schools$ = this._store.pipe(
      select(state => state.superAdmin.schools)
    );
    this.firstAdmin$ = this._store.pipe(
      select(state => state.superAdmin.firstAdmin)
    );
  }

  loadSchools() {
    this._schoolService.loadSchools()
      .subscribe(schools => this._store.dispatch(new SchoolsLoadedAction(schools)));
  }

  createSchool(school: School): void {
    this._schoolService.createSchool(school)
      .subscribe(() => this.loadSchools());
  }

  updateSchool(school: School): void {
    this._schoolService.updateSchool(school)
      .subscribe(() => this.loadSchools());
  }

  loadFirstAdminForSchool(schoolId: string): void {
    this._staffMemberService.loadFirstAdmin(schoolId)
      .subscribe(firstAdmin => this._store.dispatch(new FirstAdminLoadedAction(firstAdmin)));
  }

  saveFirstAdminForSchool(schoolId: string, firstAdmin: StaffMember) {
    this._staffMemberService.saveFirstAdminForSchool(schoolId, firstAdmin)
      .subscribe(() => this.loadFirstAdminForSchool(schoolId));

  }

  saveSchoolLogo(schoolId: string, file: File): void {
    if (file.size > this.MAX_FILE_SIZE) {
      this._snackBar.open('Le logo ne peut pas dépasser 250 Ko.', null, {duration: this.SNACKBAR_DURATION});
      return;
    }
    this._schoolService.saveSchoolLogo(schoolId, file)
      .subscribe({
          next: () => {
            this._snackBar.open('Logo sauvegardé', null, {duration: this.SNACKBAR_DURATION});
          },
          error: () => {
            this._snackBar.open('Echec de la sauvegarde du logo', null, {duration: this.SNACKBAR_DURATION});
          }
        }
      );
  }
}
